import { TWhiteLabel } from '../white-label.model';
import { getDefaultPanelColors } from './get-default-panel-colors';
import { isChosenColor } from './is-chosen-color';
import { DEFAULT_ORIGINAL_PANEL_COLORS } from './white-label-defaults.const';

export function resolveItemBgHover(whiteLabelData: TWhiteLabel): string {
  if (isChosenColor(whiteLabelData.itemBgHover, DEFAULT_ORIGINAL_PANEL_COLORS.itemBgHover)) {
    return whiteLabelData.itemBgHover;
  }

  return whiteLabelData.panelBg || getDefaultPanelColors().itemBgHover;
}
